exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comparison-line[data-v-338e1078] {\n  vertical-align: top;\n}\n.comparison-line td[data-v-338e1078] {\n  vertical-align: top;\n}\n.copied-photo[data-v-338e1078] {\n  position: absolute;\n  bottom: 0;\n  right: 10px;\n  color: #fff;\n  font-size: 3em;\n}\n.checklist-item-photo-container-small[data-v-338e1078] {\n  height: auto;\n  width: 100%;\n  margin: 2px 1px;\n  position: relative;\n  display: inline-block;\n  page-break-inside: auto;\n}\n.checklist-item-photo-small[data-v-338e1078] {\n  border-radius: 2px;\n  height: auto;\n  width: 100%;\n}\n\n", ""]);

// exports
